import { render } from "./addDoctor.vue?vue&type=template&id=6b9a7804"
import script from "./addDoctor.vue?vue&type=script&lang=js"
export * from "./addDoctor.vue?vue&type=script&lang=js"

import "./addDoctor.vue?vue&type=style&index=0&id=6b9a7804&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__